import { useCallback, useEffect, useMemo, useState } from "react";
import { getPodcasts } from "../services/podcastService";
import { Podcast } from "../types/Podcast";

export function usePodcasts() {
  const [podcasts, setPodcasts] = useState<Podcast[]>([]);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchPodcasts = useCallback(async () => {
    try {
      const podcasts = await getPodcasts();
      setPodcasts(podcasts);
    } catch (err) {
      setError(err instanceof Error ? err.message : "An error occurred");
    } finally {
      setIsLoading(false);
    }
  }, []);

  const loadMore = useCallback(async () => {
    // TODO(gmike): Implement this.
  }, []);

  useEffect(() => {
    fetchPodcasts();
  }, [fetchPodcasts]);

  return useMemo(
    () => ({
      podcasts,
      isLoading,
      error,
      loadMore,
      refetch: fetchPodcasts,
    }),
    [podcasts, isLoading, error, loadMore, fetchPodcasts],
  );
}
